import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../../../Context/AuthProvider";

const Navbar = () => {
  const { user, logOutUser } = useContext(AuthContext);
  return (
    <div className="px-4 py-5 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8">
      <div className="navbar bg-base-100">
        <div className="navbar-start">
          <div className="dropdown">
            <label tabIndex={0} className="btn btn-ghost lg:hidden">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h8m-8 6h16"
                />
              </svg>
            </label>
            <ul
              tabIndex={0}
              className="menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52"
            >
              <li>
                <Link to="/">Home</Link>
              </li>
              <li tabIndex={0}>
                <Link to="/category">Category</Link>
              </li>
              <li>
                <Link to="/blog">Blog</Link>
              </li>
              {user ? (
                <>
                  <li>
                    <Link to="/dashboard">Dashboard</Link>
                  </li>
                  <li>
                    <Link to="/">
                      <button
                        onClick={() => logOutUser()}
                        className="btn btn-outline mr-4"
                      >
                        Log Out
                      </button>
                    </Link>
                  </li>
                </>
              ) : (
                <>
                  <Link to="/login" className="btn btn-outline mr-4">
                    Log In
                  </Link>
                  <Link to="/signup" className="btn">
                    Sign Up
                  </Link>
                </>
              )}
            </ul>
          </div>
          <Link to="/" className="btn btn-ghost normal-case text-xl">
            <span className="text-teal-500 font-bold">Boi</span>Poka
          </Link>
        </div>
        <div className="navbar-end hidden lg:flex">
          <ul className="menu menu-horizontal p-0 font-bold">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/category">Category</Link>
            </li>
            <li>
              <Link to="/blog">Blog</Link>
            </li>
            {user && (
              <>
                <li>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
              </>
            )}
          </ul>

          {user ? (
            <>
              <Link to="/">
                <button
                  onClick={() => logOutUser()}
                  className="btn btn-outline mr-4"
                >
                  Log Out
                </button>
              </Link>
              {/* <button className="btn btn-outline">{user?.displayName}</button> */}
            </>
          ) : (
            <>
              <Link to="/login" className="btn btn-outline mr-4">
                Log In
              </Link>
              <Link to="/signup" className="btn">
                Sign Up
              </Link>
            </>
          )}
        </div>
        <label
          htmlFor="dashboard-drawer"
          tabIndex={1}
          className="btn btn-ghost lg:hidden"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M4 6h16M4 12h8m-8 6h16"
            />
          </svg>
        </label>
      </div>
    </div>
  );
};

export default Navbar;
